export default __webpack_public_path__ + "static/Calibre-SemiboldItalic-ad4bd95abee7bca1bdd6a93398f84a04.woff";